import { createContext } from "react";

const ComicsContext = createContext([]);

export default ComicsContext;
